
import {Component, Prop, Vue} from "vue-property-decorator";
import WorkerAddForm from "../../../../form/workerAdd/workerAdd";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";

@Component({
  components: {FormGroup}
})
export default class StaffAddFormComponent extends Vue {
  @Prop() readonly form!: WorkerAddForm;
}
